import { ChangeDetectorRef, Component, EventEmitter, forwardRef, Input, Output, OnChanges, SimpleChanges } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

interface DropdownOption {
  value: any;
  label: string;
  searchText?: string;
  [key: string]: any;
}

@Component({
  selector: 'app-admin-selection-dropdown',
  templateUrl: './admin-selection-dropdown.component.html',
  styleUrls: ['./admin-selection-dropdown.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AdminSelectionDropdownComponent),
      multi: true
    }
  ]
})
export class AdminSelectionDropdownComponent implements ControlValueAccessor, OnChanges {
  @Input() label: string = 'Select';
  @Input() placeholder: string = '';
  @Input() options: DropdownOption[] = [];
  @Input() multiple: boolean = false;
  @Input() showSearchBar: boolean = false;
  @Input() searchFields: string[] = ['label']; // Default to just label
  @Input() searchText: string = '';
  @Output() searchTextChange = new EventEmitter<string>();
  @Output() selectionChangecustom = new EventEmitter<any>();
  @Input() value: any;

  // value: any;
  filteredOptions: DropdownOption[] = [];
  onChange: (value: any) => void = () => {};
  onTouched: () => void = () => {};
  isDropdownOpen = false;

  constructor(private readonly cdr: ChangeDetectorRef) {}

  ngOnInit(): void {
    this.filterOptions();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.options || changes.searchFields) {
      this.filterOptions();
    }
    if (changes.searchText && !changes.searchText.firstChange) {
      this.filterOptions();
    }
  }

  writeValue(value: any): void {
    this.value = value;
    this.cdr.detectChanges();
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  onSelectionChange(event: any): void {
    this.value = event.value;
    this.onChange(this.value);
    this.onTouched();
    this.selectionChangecustom.emit(event.value);
    this.clearSearchText();
  }

  filterOptions(): void {
    const search = (this.searchText || '').trim().toLowerCase();

    if (!search) {
      this.filteredOptions = [...this.options];
      return;
    }

    // Create search patterns for both underscore and space versions
    const searchPatterns = [
      search,                      // original (e.g., "upload_id")
      search.replace(/_/g, ' '),   // underscore to space (e.g., "upload id")
      search.replace(/ /g, '_')    // space to underscore (e.g., "upload_id")
    ];

    this.filteredOptions = this.options.filter(option => {
      // For simple options (just value/label)
      if (!this.searchFields || this.searchFields.length === 0) {
        const optionText = `${option.value} ${option.label}`.toLowerCase();
        return searchPatterns.some(pattern => optionText.includes(pattern));
      }

      // For complex options with searchFields
      return this.searchFields.some(field => {
        if (!option[field]) return false;

        const fieldValue = String(option[field]).toLowerCase();
        return searchPatterns.some(pattern => fieldValue.includes(pattern));
      });
    });

    this.cdr.detectChanges();
  }
  clearSearchText(): void {
    this.searchText = '';
    this.searchTextChange.emit(this.searchText);
    this.filterOptions();
  }
}
